<ng-template [ngIf]="false">
  <!--
  https://www.figma.com/file/3Al7WB7BIaZbcOXYlk2gz5/Lingo-Production-2?node-id=178%3A9219&viewport=7176%2C671%2C0.6818868517875671
  -->
</ng-template>

<div class="vocabulary-playmode">
  <h2 class="title bold">Выберите режим прохождения</h2>

  <div class="cards" *ngIf="vocabularyStudy">
    <div class="card" [class.active]="cardMouseOverState['classic']" (click)="rotateCard('classic')">
      <div class="card-body card-body--front">
        <div class="card-info">
          <h3 class="mode-label bold">Классика</h3>
          <p class="mode-text medium">Сценарии с возрастающей сложностью</p>
        </div>
        <div class="card-action medium" (click)="selectScenarioPlayMode()">Начать</div>
      </div>

      <div class="card-body card-body--back">
        <div class="card-info card-info--back">
          <h3 class="mode-label bold">Классика</h3>
          <p class="mode-text medium">Ваш прогресс</p>
          <ul class="list">
            <li class="list-item" *ngFor="let item of scenarios; trackBy: trackByFn" (click)="selectScenarioPlayMode(item)">
              <div class="list-icon-wrap">
              </div>
              <span class="list-item-text medium" [class.active]="item.active">{{ item.title | customLocale }}</span>
            </li>
          </ul>
        </div>
        <div class="card-action medium" (click)="selectScenarioPlayMode()">Начать</div>
      </div>
    </div>

    <div class="card" [class.active]="cardMouseOverState['memorizer']" (click)="rotateCard('memorizer')">
      <div class="card-body card-body--front">
        <div class="card-info">
          <div class="icon-wrap">
          </div>
          <h3 class="mode-label bold">Меморайзер</h3>
          <p class="mode-text medium">Прохождение случайного сценария</p>
        </div>
        <div class="card-action" (click)="selectMemorizerPlayMode()">Начать</div>
      </div>

      <div class="card-body card-body--back">
        <div class="card-info card-info--back">
          <h3 class="mode-label bold">Меморайзер</h3>
          <p class="mode-text medium">Ваш прогресс</p>
          <div class="progress-wrap">
            <app-simple-pie-chart
              [max]="termsSelected"
              [value]="termsStudied">
            </app-simple-pie-chart>
          </div>
          <span class="progress-label medium">Слов изучено</span>
        </div>
        <div class="card-action" (click)="selectMemorizerPlayMode()">Начать</div>
      </div>
    </div>

    <div class="card" [class.active]="cardMouseOverState['final']" (click)="rotateCard('final')">
      <div class="card-body card-body--front">
        <div class="card-info">
          <div class="icon-wrap">
          </div>
          <h3 class="mode-label bold">Финальный тест</h3>
          <p class="mode-text medium">Проверка изученного материала</p>
        </div>
        <div class="card-action" (click)="selectTestPlayMode()">Начать</div>
      </div>

      <div class="card-body card-body--back">
        <div class="card-info card-info--back">
          <h3 class="mode-label bold">Финальный тест</h3>
          <p class="mode-text medium">Ваш прогресс</p>
          <div class="progress-wrap">
            <span *ngIf="testGrade" class="rating normal">{{ testGrade }}</span>
            <span *ngIf="!testGrade" class="no-rating bold">N/A</span>
          </div>
          <span *ngIf="testGrade" class="progress-label medium">Ваша оценка</span>
          <span *ngIf="!testGrade" class="progress-label medium">Нет оценки</span>
        </div>
        <div class="card-action" (click)="selectTestPlayMode()">Начать</div>
      </div>
    </div>

    <!--
    <div class="card" [class.active]="cardMouseOverState['game']" (click)="rotateCard('game')">
      <div class="card-body card-body--front">
        <div class="card-info">
          <div class="icon-wrap">
          </div>
          <h3 class="mode-label bold">Играть</h3>
          <p class="mode-text medium">Соревнования с другими пользователям</p>
        </div>
        <div class="card-action" (click)="selectMultiplayerPlayMode()">Начать</div>
      </div>

      <div class="card-body card-body--back">
        <div class="card-info card-info--back">
          <h3 class="mode-label bold">Играть</h3>
          <p class="mode-text medium">Ваш прогресс</p>
          <div class="progress-wrap">
            <app-simple-pie-chart
              [max]="gameLevel"
              [value]="termsSelected"
              showType="vertical">
            </app-simple-pie-chart>
          </div>
          <span class="progress-label medium">Уровень {{ nextGameLevel }} через: {{ nextGameLevelProgressDiff }}</span>
        </div>
        <div class="card-action" (click)="selectMultiplayerPlayMode()">Начать</div>
      </div>
    </div>
    -->
  </div>

  <span class="info normal" (click)="options.emit(true)">Вы изучаете {{ termsSelected }} карточек
    <span class="info info--change normal">изменить</span>
  </span>
</div>
